import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

type SyncEntry = {
  bron: string;
  status: string;
  records_updated: number;
  error_message: string | null;
  completed_at: string;
};

export function useLaadpleinSyncStatus() {
  const { data: syncLog, isLoading } = useQuery({
    queryKey: ['laadplein-sync-status'],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('laadplein_data_sync_log')
        .select('bron, status, records_updated, error_message, completed_at')
        .order('started_at', { ascending: false })
        .limit(20);

      if (error) throw error;

      // Group by bron, take latest
      const latest: Record<string, SyncEntry> = {};
      for (const row of (data || []) as SyncEntry[]) {
        if (!latest[row.bron]) {
          latest[row.bron] = row;
        }
      }
      return latest;
    },
    refetchInterval: 60_000,
  });

  const getStatus = (bron: string) => {
    const entry = syncLog?.[bron];
    if (!entry) return { status: 'never' as const, lastSync: null, error: null, records: 0 };
    return {
      status: entry.status,
      lastSync: entry.completed_at,
      records: entry.records_updated,
      error: entry.error_message,
    };
  };

  return { syncLog, isLoading, getStatus };
}
